import type { Spell } from '../types';

// Import the spellcards spells JSON directly - Vite will bundle this at build time
// To update spells: run `npm run scrape-spellcards-spells`
import spellcardsSpells from '../../public/spellcards-spells.json';

// Export the spells array with proper typing
export const spells: Spell[] = spellcardsSpells as Spell[];
